import { Action } from '@agile-actors/actions/js';

const namespaceAction = Action('@@contact-form');
const contactFormMessage = namespaceAction('MESSAGE');

export { contactFormMessage };
